<template>
    <div class="order-infoTab-section1">
        <div class="order-pay-record">
            <p v-if="isOrderSensitiveMasked">
                订单共计应到款金额：<strong>******</strong>元。实到款：<strong>******</strong>元，未到款：<strong>******</strong>元
            </p>
            <p v-else>
                订单共计应到款金额：<strong>{{totalPlanAmount.toFixed(2)}}</strong>元。实到款：<strong>{{totalActualAmount.toFixed(2)}}</strong>元，未到款：<strong v-if="totalPlanAmount>totalActualAmount">{{(totalPlanAmount
                - totalActualAmount).toFixed(2)}}</strong><strong v-else>0</strong>元</p>
            <el-table
                    :data="payments"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="order_id"
                        label="成交订单ID">
                </el-table-column>
                <el-table-column prop="plan_amount" label="计划回款金额">
                </el-table-column>
                <el-table-column prop="actual_amount" label="实际回款金额">
                </el-table-column>
                <el-table-column label="未回款金额">
                    <template slot-scope="scope">
                        <span>{{scope.row.sensitive_masked ? '******' : (scope.row.no_pay == 0 ? '回款已完成' : _.round(scope.row.no_pay, 2))}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="actual_at" label="实际回款时间">
                    <template slot-scope="scope">
                        <span v-if="scope.row.actual_at">{{scope.row.actual_at}}</span>
                        <span style="color:red;" v-else>未更新回款信息,请催账！</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage"></pagination>
        </el-row>
    </div>
</template>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import order from "~/services/order";
    import common from "~/services/common";

    export default {
        data() {
            return {
                totalPlanAmount: 0,  //计划回款金额
                totalActualAmount: 0,  //实际回款金额
                linkPage: null,
                payments: []
            }
        },
        components: {
            Pagination
        },
        computed: {
            isOrderSensitiveMasked() {
                return this.payments.some(item => item.sensitive_masked || item.order_sensitive_masked);
            }
        },
        watch: {
            $route: function (to, from, next) {
                let params = {};
                params['customer_id'] = to.query["id"];
                params['page'] = to.query["page"];
                params['perPage'] = to.query["perPage"];
                this.getPaymentLogs(params);
            }
        },
        created: function () {
            this.getPaymentLogs({'customer_id': this.$route.query["id"]});
        },
        methods: {
            getPaymentLogs(params) {
                common.getPayment(params).then(res => {
                    if (res && res.code == 0) {
                        this.payments = res.data;
                        this.linkPage = res._meta;
                        this.totalPlanAmount = 0;
                        this.totalActualAmount = 0;
                        if (!this.isOrderSensitiveMasked) {
                            this.payments.forEach((item, index) => {
                                this.totalPlanAmount += Number(item.plan_amount);
                                this.totalActualAmount += Number(item.actual_amount);
                            });
                        }
                    }
                })
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/customer/PaymentLogs.vue